<template lang="pug">
.container
  .content-processos
    .processos-main
      el-card.card-container(shadow="hover")
        b Solicitar liberação de cláusula resolutiva:
        .dados-processo
          span Selecione o processo que deseja solicitar liberação de cláusula resolutiva:
          el-radio(v-model="radioValue" :label="this.isMaranhao" :disabled="!this.isMaranhao" ) Processo SiCARF
          el-radio(v-model="radioValue" :label="!this.isMaranhao") Processo Físico
          validation-observer.align(ref='validation' tag='form')
            el-col(v-if="this.isMaranhao" :span="8" style="flex: 1")
                  validation-provider(rules="required", v-slot="{ errors }", name="Tipo Título")
                    app-label(label="Selecione o tipo de título:")
                    el-select(
                      clearable,
                      filterable,
                      default-first-option=false,
                      name="tipo titulo",
                      collapse-tags,
                      v-model="tipoTitulo",
                    )
                      el-option(
                        v-for="item in tiposTitulo",
                        :key="item.key",
                        :label="item.value",
                        :value="item.value",
                      )
                    span.help.erro {{ errors[0] }}
            el-col(:span="8" style="flex: 1")
                validation-provider(:rules="getRulesNumeroProcesso()", v-slot="{ errors }", name="Número Processo")
                  div(style="display: flex")
                    app-label(label="Insira o número do processo:" :required="!!getRulesNumeroProcesso()")
                    el-tooltip(
                      style="margin-left: 3%"
                      effect='light',
                      placement='right'
                    )
                      span(slot="content")
                        p O número do processo se encontra no título do imóvel
                      i.el-icon-info
                  el-input.input(
                    v-model="numeroProcesso"
                    name="Número Processo"
                    :class="{'erro' : errors.length}"
                  )
                  span.help.erro {{ errors[0] }}
            el-col(:span="8" style="flex: 1")
                validation-provider(:rules="getRulesNumeroProcesso()", v-slot="{ errors }", name="Número Título Dominial")
                  app-label(label="Insira o número do Título do Domínio:" :required="!!getRulesNumeroProcesso()")
                  el-input.input(
                    v-model="numeroTituloDominial"
                    name="Número Título Dominial"
                    :class="{'erro' : errors.length}"
                  )
                  span.help.erro {{ errors[0] }}
            el-col(:span="8")
                validation-provider(rules="required", v-slot="{ errors }", name="Data de emissão do documento")
                    div(style="display: flex")
                      app-label(label="Data de emissão do documento:")
                      el-tooltip(
                        style="margin-left: 3%"
                        effect='light',
                        placement='right'
                      )
                        span(slot="content")
                          p Data de emissão do título de domínio, escritura pública de compra e venda ou outro documento
                        i.el-icon-info
                    el-date-picker.input(
                      style="width: inherit"
                      type="date",
                      name="Data de emissão do documento"
                      v-model="dataEmissaoTituloDominial",
                      placeholder="Selecione",
                      format="dd/MM/yyyy",
                      v-mask="'##/##/####'",
                      :picker-options="pickerOptions",
                      :class="{'erro' : errors.length}"
                    )
                    span.help.erro {{ errors[0] }}
        app-buttons-cadastro.alinhar(
          :showButtonProximo="true"
          :isPrimeiroPasso="true"
          @cancelar="cancelar()"
          @proximo="proximo()"
        )
        el-dialog(
          title='Atenção'
          :visible.sync='dialogVisible'
          width='30%'
          center=""
          )
          span Prezado usuário, você não pode solicitar liberação de cláusulas resolutivas para este processo pois ainda <b>não cumpriu</b> o prazo de 10 (dez) anos como Titular do Imóvel
          span.dialog-footer(slot='footer')
            el-button(type='primary' @click='dialogVisible = false') Ok
</template>

<script>
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions, mapGetters } from 'vuex'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import empty from '../cadastros/maranhao/empty/emptyLiberacaoClausulaResolutiva'
import { cloneDeep } from 'lodash'
import AppLabel from '@/components/AppLabel'
import moment from 'moment'

export default {

  mixins: [
    AppNotificacao
  ],

  components: {
    AppButtonsCadastro,
    AppLabel
  },

  props: {
    required: {
      type: Boolean,
      default: true
    },
    observer: {
      type: Object
    }
  },

  data () {
    return {
      radioValue: true,
      numeroProcesso: '',
      dataEmissaoTituloDominial: '',
      numeroTituloDominial: '',
      cadastro: cloneDeep(empty),
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      dialogVisible: false,
      isMaranhao: process.env.ESTADO === 'ma',
      tiposTitulo: [
        {
          key: 1,
          value: 'Título de domínio'
        },
        {
          key: 2,
          value: 'Escritura Pública de Compra e Venda'
        },
        {
          key: 3,
          value: 'Outros'
        }
      ],
      tipoTitulo: '',
      emitidoAMenos10Anos: null
    }
  },

  created () {
    if (this.isMaranhao) {
      this.cadastro.json['tipoProcesso'] = 'Processo SiCARF'
    }
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    })
  },

  methods: {
    ...mapActions({
      salvarCadastro: 'cadastro/salvarCadastro',
      finalizarCadastro: 'cadastro/finalizarCadastro'
    }),

    cancelar () {
      this.$router.push({
        name: this.$route.path.split('/')[1] + '/liberacao-clausula',
        params: {},
        props: {
          isLiberacao: true
        }
      })
    },

    showDialogo () {
      this.dialogVisible = true
    },

    verificaDiferencaData () {
      const now = moment()
      const start = moment(this.dataEmissaoTituloDominial)
      const duration = moment.duration(moment(now).diff(start))
      const years = duration.asYears()
      if (years < 10) {
        this.showDialogo()
      }
    },

    getRulesNumeroProcesso () {
      return this.isMaranhao ? this.tipoTitulo === 'Título de domínio' ? 'required' : '' : 'required'
    },

    formataRots () {
      return this.$route.path.includes('central') ? '' : this.$route.path.split('/')[1] + '/'
    },

    async validarCampos () {
      return this.$refs.validation.validate()
    },

    async proximo () {
      const validado = await this.validarCampos()
      if (!validado) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS
        )
        return
      }
      if (this.dialogVisible === true) {
        return
      }
      try {
        this.cadastro.usuario.id = this.usuario.id
        this.cadastro.json.numeroProcesso = this.numeroProcesso
        this.cadastro.json.dataEmissaoTituloDominial = this.dataEmissaoTituloDominial
        this.cadastro.json.numeroTituloDominial = this.numeroTituloDominial
        this.cadastro.json.interessado.pessoa.tipo = 'PF'
        this.cadastro.json = JSON.stringify(this.cadastro.json)
        const response = await this.salvarCadastro(this.cadastro)
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.DADOS_SALVOS_SUCESSO
        )
        await this.$router.push({
          name: this.formataRots() + 'liberacao-clausula/cadastrante',
          params: {
            idCadastro: response.id
          }
        })
      } catch (error) {
        console.error(error)
      }
    }
  },

  watch: {
    radioValue (val) {
      if (this.isMaranhao) {
        if (val) {
          this.cadastro.json['tipoProcesso'] = 'Processo SiCARF'
        } else {
          this.cadastro.json['tipoProcesso'] = 'Processo Físico'
        }
      }
    },

    tipoTitulo (val) {
      if (this.isMaranhao) {
        this.cadastro.json['tipoTitulo'] = val
      }
    },

    dataEmissaoTituloDominial (val) {
      if (this.isMaranhao) {
        const date10AnosAtras = new Date(new Date().setYear(new Date().getFullYear() - 10))
        this.cadastro.json['documentoEmitidoAMenos10Anos'] = new Date(val) > date10AnosAtras
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .content-processos {
    flex: 1;
    padding: 20px;
  }

  .processos-main {
    padding: 10px 0;
    height: 81vh;
  }

  .dados-processo {
    display: flex;
    flex-direction: column;
    gap: 3vh;
    margin-top: 1%;
  }

  .alinhar {
    display: flex;
    justify-content: center;
  }

  #numero-processo {
    display: flex;

    #title {
      width: 15%;
      display: flex;
      text-align: center;
      align-items: center;
    }

    .el-input {
      width: fit-content;
    }
  }

  .align {
    display: flex;
    justify-content: center;
    width: 100%;
    gap: 7%;
  }
</style>



// WEBPACK FOOTER //
// src/screens/central/liberacao/EscolhaTipoProcesso.vue